import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AgentMemberSearchResult } from "src/app/models/agent";

import { AgentService } from "src/app/services/agent.service";

import { MemberSearchResult } from "src/app/models/member-lookup";
import { ContentHeaderKey } from "src/app/constants/content-header";

@Component({
    selector: 'mwp-member-lookup-history',
    templateUrl: './lookup-history.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CounselorMemberLookupHistoryComponent implements OnInit {
    public members: AgentMemberSearchResult[];
    public member: MemberSearchResult;
    public displayConfirmMember: boolean;
    public apiUrl = ContentHeaderKey.CounselorLookupHistory;

    constructor(
        private agentService: AgentService,
    ) {
    }

    ngOnInit() {
        this.agentService.getAgentMemberSearchHistory().subscribe((response: AgentMemberSearchResult[]) => {
            this.members = response;
        });
    }

    public selectedMember(selectedMember: MemberSearchResult): void {
        this.displayConfirmMember = true;
        this.member = selectedMember;
    }

    public back(): void {
        this.displayConfirmMember = false;
    }
}